var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48ZM35.2971 33.8166C35.7471 33.3791 36 32.7856 36 32.1667V19.3333C36 18.7145 35.7471 18.121 35.2971 17.6834C34.847 17.2458 34.2365 17 33.6 17H22.7999L20.3999 13.4999H14.3999C13.7633 13.4999 13.1529 13.7458 12.7028 14.1834C12.2527 14.6209 11.9999 15.2144 11.9999 15.8333V32.1667C11.9999 32.7856 12.2527 33.3791 12.7028 33.8166C13.1529 34.2542 13.7633 34.5001 14.3999 34.5001H33.6C34.2365 34.5001 34.847 34.2542 35.2971 33.8166Z",
    fill: "#9DA1AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlow);
export default __webpack_public_path__ + "static/media/flow.e983289d6f9a9a9c5a3f16d04c41b830.svg";
export { ForwardRef as ReactComponent };